/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VideoTutorial } from '../../models/video-tutorial';

export interface DeleteVideoTutorial$Params {
  ref: string;
}

export function deleteVideoTutorial(http: HttpClient, rootUrl: string, params: DeleteVideoTutorial$Params, context?: HttpContext): Observable<StrictHttpResponse<VideoTutorial>> {
  const rb = new RequestBuilder(rootUrl, deleteVideoTutorial.PATH, 'delete');
  if (params) {
    rb.path('ref', params.ref, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VideoTutorial>;
    })
  );
}

deleteVideoTutorial.PATH = '/v1/api/admin-ui/video-tutorial/delete/{ref}';
